import {FormattedMessage} from "react-intl";
import React, { Component } from "react";
import {Link} from "react-router-dom";

class StencilQuantity extends Component {
    constructor(props){
        super(props);
        this.state= {
            qty : this.props.selectedId
        };

        this.setStencilQty = this.setStencilQty.bind(this);
        this.onBlurStencilQty = this.onBlurStencilQty.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps !== this.props){
            this.setState({
                qty : this.props.selectedId
            })
        }
    }
    componentDidMount() {
        let selectedSide = this.props.stnclParams;
        let qtyValue =this.props.selectedId;
        if(selectedSide === 3){
            qtyValue = 2;
        }else {
            qtyValue = this.props.selectedId;
        }

        this.setState({
            qty : qtyValue
        })
    }

    setStencilQty = (event) => {
        this.setState({
            qty : event.target.value
        })

    };

    onBlurStencilQty = (event) => {

        let regex = new RegExp('^[1-9]([0-9]*)(\.[0-9]{0,1})?$');
        if(regex.test(event.target.value)){
            this.props.setQuantity(event);
        }else{
            this.setState({
                qty : this.props.selectedId
            })
        }

        // this.props.setDimensions(event);
    };

    render() {

        return (
            <div className="row">
                <div className="col-md-12 no-padding">
                    <div className="stencil-details-div">
                        <div className="col-md-3 text-right stencil-content-item-heading">
                            <FormattedMessage id="app.stencil-quotation.stencil-quantity"
                                              defaultMessage="Stencil Quantity"
                                              description=""
                            />
                            &nbsp; &nbsp;
                            {/*<Link id="pcbstnclQty-qLink" to="/help/stncl_qty" className="glyphicon glyphicon-question-sign question-link"></Link>*/}
                        </div>
                        <div className="btn-group col-md-1 stencil-details-div-items stencil-details-div-items2">
                            <input value={this.state.qty} onChange={this.setStencilQty} onBlur={this.onBlurStencilQty} type="text"
                                   className="form-control input-sm input-stencil-qty"
                                   name="stencil_qty"/>
                        </div>
                        <div className="col-md-8">

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default StencilQuantity;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBWithStencilForm/PCBWithStencilFormFields/StencilQuantity.js